import { removeStored } from '@/utils/removeStored'
import uuid from '@/utils/uuid'
import { anonymize } from '@mercadoni/sinister/dist/cjs/monitors/services'
import { selectedMutations } from '@mercadoni/sinister/dist/cjs/shared/services'
import { setStore } from '@mercadoni/sinister/dist/cjs/shared/utils'

interface CleanStoredInfoResult {
  success: boolean
  errors?: string[]
}

const cleanStoredInfo = async (): Promise<CleanStoredInfoResult> => {
  console.log(' ~ cleanStoredInfo: START')
  const errors: string[] = []

  try {
    // anonymize
    anonymize(uuid())
  } catch (error) {
    const errorMessage = `Failed to anonymize: ${
      error instanceof Error ? error.message : 'Unknown error'
    }`
    console.error(errorMessage)
    errors.push(errorMessage)
  }

  try {
    // Remove all stored data in batches to avoid race conditions
    const allKeysToRemove = [
      // cart cookies
      'cartState',
      'selectedAddress',
      'guestAddress',
      'selectedOpsModel',
      'cartId',
      'cart',
      // store cookies
      'storeReference',
      'selectedStore', // legacy
      'selectedAlphaStore', // legacy
      'selectedStoreId',
      'storeId',
      // stored info
      'instructions',
      'lastSuggestionTime',
      'storeFilter',
      'noFed',
      // auth cookies
      'token',
      'configs',
      'customer',
      'logged',
    ]

    removeStored(allKeysToRemove)
  } catch (error) {
    const errorMessage = `Failed to remove stored data: ${
      error instanceof Error ? error.message : 'Unknown error'
    }`
    console.error(errorMessage)
    errors.push(errorMessage)
  }

  try {
    // set store to empty for customer
    setStore('customer', '{}')
  } catch (error) {
    const errorMessage = `Failed to clear store: ${
      error instanceof Error ? error.message : 'Unknown error'
    }`
    console.error(errorMessage)
    errors.push(errorMessage)
  }

  try {
    // legacy logOut
    await selectedMutations.logOut() // Apollo logOut
  } catch (error) {
    const errorMessage = `Failed to logout from Apollo: ${
      error instanceof Error ? error.message : 'Unknown error'
    }`
    console.error(errorMessage)
    errors.push(errorMessage)
  }

  try {
    if (typeof window !== 'undefined') {
      localStorage.clear()
      sessionStorage.clear()
    }
  } catch (error) {
    const errorMessage = `Failed to clear browser storage: ${
      error instanceof Error ? error.message : 'Unknown error'
    }`
    console.error(errorMessage)
    errors.push(errorMessage)
  }

  console.log(' ~ cleanStoredInfo: END')

  return {
    success: errors.length === 0,
    errors: errors.length > 0 ? errors : undefined,
  }
}

export default cleanStoredInfo
